import common from '../common';

export default {
  jpath: ['spectra', 'mass'],
  find: common.basenameFind,
  getProperty: common.getTargetProperty,
  process: common.getMetaFromJcamp,
};
